import { z } from "zod";

/** Wird sowohl im Client (Formular) als auch im Server (API) verwendet. */
export const contactSchema = z.object({
  // Auswahl aus dem mehrstufigen Formular
  topic: z.string().min(1, "Bitte ein Thema wählen.").max(80),
  budget: z.string().max(40).optional().default(""),
  // Kontaktdaten
  name: z.string().min(2, "Bitte Namen angeben.").max(120),
  email: z.string().email("Bitte eine gültige E-Mail-Adresse angeben.").max(160),
  phone: z.string().max(40).optional().default(""),
  company: z.string().max(160).optional().default(""),
  message: z.string().min(10, "Bitte kurz beschreiben, worum es geht.").max(5000),
  // DSGVO-Einwilligung
  consent: z.literal(true, { message: "Bitte der Verarbeitung zustimmen." }),
  /*
   * Honeypot – für Menschen unsichtbar, Bots füllen ihn aus.
   * Bewusst NICHT auf max(0) begrenzt: Sonst schlägt schon die Validierung
   * fehl und der Bot bekommt eine Fehlermeldung als Rückmeldung, dass er
   * erkannt wurde. Stattdessen darf der Wert durch, und die Route meldet
   * still Erfolg – der Bot hält die Adresse für funktionierend und zieht
   * weiter, statt es mit einer anderen Umgehung zu versuchen.
   */
  website: z.string().max(200).optional().default(""),
});

export type ContactInput = z.infer<typeof contactSchema>;

export const contactTopics = [
  { value: "softwareentwicklung", label: "Software entwickeln lassen", icon: "code" },
  { value: "it-consulting", label: "IT-Beratung / Consulting", icon: "compass" },
  { value: "it-betreuung", label: "IT-Betreuung zum Fixpreis", icon: "shield-check" },
  { value: "kuenstliche-intelligenz", label: "KI-Lösung / Chatbot", icon: "sparkles" },
  { value: "webdesign", label: "Website / Webdesign", icon: "dashboard" },
  { value: "seo", label: "SEO – bei Google gefunden werden", icon: "search" },
  { value: "google-ads", label: "Google Ads schalten", icon: "target" },
  { value: "nis2", label: "NIS2 / Informationssicherheit", icon: "lock" },
  { value: "qa", label: "Qualitätssicherung / Testing", icon: "shield-check" },
  { value: "sonstiges", label: "Etwas anderes", icon: "bolt" },
] as const;

export const contactBudgets = [
  { value: "unklar", label: "Noch offen / weiß nicht" },
  { value: "bis-5k", label: "bis 5.000 €" },
  { value: "5-15k", label: "5.000 – 15.000 €" },
  { value: "15-40k", label: "15.000 – 40.000 €" },
  { value: "ab-40k", label: "ab 40.000 €" },
] as const;

export function topicLabel(value: string): string {
  return contactTopics.find((t) => t.value === value)?.label ?? value;
}

export function budgetLabel(value: string): string {
  return contactBudgets.find((b) => b.value === value)?.label ?? value;
}
